/** @format */

import {
  authApi,
  type LoginRequest,
  type LoginResponse,
  type ConfigurationsResponse,
} from "../lib/api/auth.ts";

export const authService = {
  login: (credentials: LoginRequest): Promise<LoginResponse> =>
    authApi.login(credentials),
  refreshToken: (refresh: string) => authApi.refreshToken(refresh),
  getConfigurations: (): Promise<ConfigurationsResponse> =>
    authApi.getConfigurations(),
};
